export default __webpack_public_path__ + "static/media/quiz-icon.e126eba9.png";